import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DetailsViewComponent,
  NoDataComponent,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { Guid, isNotEmptyArray, isNotNil } from '@web/utils';
import { toObservable } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs';
import { AdminBoxSaleDataSourceService } from '../../services/admin-box-sale-data-source.service';
import { BoxComponentGroupCosmeticsTableComponent } from '@web/shared/module/shop';
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionPanel,
} from 'primeng/accordion';
import { SummernoteHtmlPreviewComponent } from '@web/shared/external';
import { AdminBoxSaleGroupsPreviewComponent } from '../../components/admin-box-sale-groups-preview/admin-box-sale-groups-preview.component';

@Component({
  selector: 'app-admin-box-sale-details',
  imports: [
    Accordion,
    AccordionContent,
    AccordionHeader,
    AccordionPanel,
    BoxComponentGroupCosmeticsTableComponent,
    CommonModule,
    DetailsViewComponent,
    NoDataComponent,
    SpinnerFilledComponent,
    SummernoteHtmlPreviewComponent,
    AdminBoxSaleGroupsPreviewComponent,
  ],
  templateUrl: './admin-box-sale-details.component.html',
  styleUrl: './admin-box-sale-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxSaleDetailsComponent {
  public readonly id = input.required<Guid>();

  private readonly dataSource = inject(AdminBoxSaleDataSourceService);
  protected readonly details$ = toObservable(this.id).pipe(
    switchMap((id) => this.dataSource.fetchDetailsById(id)),
  );
  protected readonly isNotEmptyArray = isNotEmptyArray;
  protected readonly isNotNil = isNotNil;
}
